import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Switch,
} from '@mui/material';

interface NotificationsTabProps {
  colors: any;
  glassStyle: any;
}

const NotificationsTab: React.FC<NotificationsTabProps> = ({ colors, glassStyle }) => {
  return (
    <Box>
      <Typography variant="h5" fontWeight={800} color={colors.textPrimary} sx={{ mb: 1 }}>
        Notifications
      </Typography>
      <Paper elevation={0} sx={{ bgcolor: colors.cardBg, borderRadius: '24px', p: 4, ...glassStyle }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography fontWeight={700} color={colors.textPrimary}>Enable Desktop Notifications</Typography>
          <Switch defaultChecked color="success" />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography fontWeight={700} color={colors.textPrimary}>Enable Unread Message Badge</Typography>
          <Switch defaultChecked color="success" />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography fontWeight={700} color={colors.textPrimary}>Taskbar Flashing</Typography>
          <Switch color="success" />
        </Box>
      </Paper>
    </Box>
  );
};

export default NotificationsTab;